import { render } from "./CatalogManage.vue?vue&type=template&id=12236214&scoped=true"
import script from "./CatalogManage.vue?vue&type=script&lang=js"
export * from "./CatalogManage.vue?vue&type=script&lang=js"

import "./CatalogManage.vue?vue&type=style&index=0&id=12236214&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12236214"]])

export default __exports__